import React from "react"
import { useForm } from "react-hook-form"
import { TriggerNodeData, WorkflowNode } from "lib/types/workflow"

import Input from "components/Ui/Form/Input"
import { FormSection, SaveButton } from "./NodeEditorSidebar.styled"

type Props = {
  node: WorkflowNode
  onSave: (nodeId: string, data: TriggerNodeData) => void
}

interface FormValues {
  label: string
}

const TriggerNodeForm = ({ node, onSave }: Props) => {
  const data = node.data as TriggerNodeData
  const { register, handleSubmit, formState: { errors } } = useForm<FormValues>({
    defaultValues: { label: data.label }
  })

  const onSubmit = (values: FormValues) => {
    onSave(node.id, {
      ...data,
      label: values.label
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormSection>
        <Input
          name="label"
          label="Name"
          register={register}
          validation={{
            required: "Name is required",
            maxLength: { value: 100, message: "Name must be at most 100 characters" }
          }}
          errors={errors}
        />
      </FormSection>
      <FormSection>
        <Input
          name="triggerType"
          label="Trigger Type"
          defaultValue={data.triggerType}
          disabled
        />
      </FormSection>
      <SaveButton type="submit">Update Node</SaveButton>
    </form>
  )
}

export default TriggerNodeForm
